import { RangeSummary } from "../../../models/RangeSummary";

export const getRangeSummary = (data: any): RangeSummary => ({
  count: Number(data.count),
  withAmountCount: Number(data.with_amount_count),
  totalAmount: data.total_amount != null ? Number(data.total_amount) : 0,
  // total_weight (tons) is present only for dump-event receipts; left undefined
  // for driver dump/fuel receipts so the tons line is omitted there.
  totalWeight: data.total_weight != null ? Number(data.total_weight) : undefined,
});
